import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { path } from 'ramda';
import qs from 'query-string';
import { axiosBeelineRequest } from '@beef/utils';
import store from "../../../store/store";
import { SET_ERROR, SET_HIDDEN_FIELDS, SET_LOGIN_MODEL, SET_MOBILE_ID_DATA } from "./actionTypes";
export var personalCabinetLink = store.createAction({
  name: 'personalCabinetLink',
  path: ['personalCabinetLink'],
  defaultState: null,
  dispatches: ['set']
});
export var setHiddenFields = function setHiddenFields(dispatch, getState) {
  var _getState$external;
  var loginModel = (_getState$external = getState().external) === null || _getState$external === void 0 ? void 0 : _getState$external.loginModel;
  if (!loginModel) return;
  var returnUrl = loginModel.returnUrl,
    clientId = loginModel.clientId,
    state = loginModel.state,
    nonce = loginModel.nonce,
    requestScope = loginModel.requestScope;
  var hiddenFields = {
    client_id: clientId,
    redirect_uri: returnUrl,
    response_type: 'id_token',
    response_mode: 'form_post',
    state: state,
    scope: requestScope,
    nonce: nonce,
    remember_me: true
  };
  dispatch({
    type: SET_HIDDEN_FIELDS,
    payload: hiddenFields
  });
};
export var fetchLoginModel = function fetchLoginModel(CTN) {
  return function (dispatch, getState) {
    var _ref = path(['external', 'loginModel'], getState()) || {},
      fetched = _ref.fetched,
      loading = _ref.loading;
    if (fetched && !CTN || loading) {
      return Promise.resolve();
    }
    var _qs$parse = qs.parse(window.location.search),
      returnUrl = _qs$parse.returnUrl;
    var params = qs.stringify({
      CTN: CTN,
      returnUrl: returnUrl
    });
    dispatch({
      type: SET_LOGIN_MODEL,
      payload: {
        loading: true
      }
    });
    return axiosBeelineRequest({
      url: "/menu/loginmodel/".concat(params && "?".concat(params)),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (data) {
      if (data.mobileId) {
        dispatch({
          type: SET_MOBILE_ID_DATA,
          payload: _objectSpread(_objectSpread({}, data.mobileId), {}, {
            bisIncludeCredentials: data.bisIncludeCredentials,
            bisUrl: data.bisUrl
          })
        });
      }
      dispatch({
        type: SET_LOGIN_MODEL,
        payload: _objectSpread(_objectSpread({}, data), {}, {
          loading: false,
          fetched: true
        })
      });
      dispatch(setHiddenFields);
      return Promise.resolve(data);
    }).catch(function (e) {
      dispatch({
        type: SET_ERROR,
        payload: e
      });
      dispatch({
        type: SET_LOGIN_MODEL,
        payload: {
          loading: false
        }
      });
      return Promise.reject(e);
    });
  };
};
export var changeAccount = function changeAccount(accountId, ctn) {
  return function (dispatch, getState) {
    var list = getState().external.ctnList;
    if (!list) {
      dispatch({
        type: SET_ERROR,
        payload: 'no ctn list'
      });
      return Promise.reject(new Error('no ctn list'));
    }
    var _list$accountId = list[accountId],
      defaultCtn = _list$accountId.defaultCtn,
      login = _list$accountId.login,
      isActive = _list$accountId.isActive,
      profileUrl = _list$accountId.profileUrl;
    var ctnToSwitch = defaultCtn;
    if (ctn && ctn.ctn) {
      ctnToSwitch = ctn.ctn;
    } else if (!ctnToSwitch) {
      ctnToSwitch = login;
    }
    if (isActive) {
      return Promise.resolve().then(function () {
        window.location.href = profileUrl;
      });
    }
    return axiosBeelineRequest({
      method: 'post',
      url: '/SsoSwitcher/SetCtn',
      data: {
        login: login,
        ctn: ctnToSwitch
      },
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function () {
      window.location.href = profileUrl;
    }).catch(function (error) {
      return dispatch({
        type: SET_ERROR,
        payload: error
      });
    });
  };
};